import { render, staticRenderFns } from "./warehouse-allocation-plan-add.vue?vue&type=template&id=0f57a8e8&scoped=true"
import script from "./warehouse-allocation-plan-add.vue?vue&type=script&lang=js"
export * from "./warehouse-allocation-plan-add.vue?vue&type=script&lang=js"
import style0 from "./warehouse-allocation-plan-add.vue?vue&type=style&index=0&id=0f57a8e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57a8e8",
  null
  
)

export default component.exports